import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import $ from 'jquery';
import 'bootstrap';
import 'popper.js';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/awesome/css/font-awesome.min.css';
import './assets/css/site.css';

Vue.config.productionTip = false;
Vue.prototype.$=$;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
